import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';
// @ts-ignore
import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';
export interface BvPopoverBodySignature {
    Args: {
        flush?: boolean;
        popover?: Dropdown;
        scrollable?: boolean;
    };
    Blocks: {
        default: [popover?: Dropdown];
    };
    Element: HTMLDivElement;
}
const BvPopoverBodyComponent: TOC<BvPopoverBodySignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <div
    class={{classNames
      'bv-popover__body'
      (if (orElse @scrollable true) 'u-scrollable-y')
      (if @flush 'bv-popover__body--flush')
    }}
    ...attributes
  >
    {{yield @popover}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvPopoverBodyComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvPopover::Body': typeof BvPopoverBodyComponent;
        'bv-popover/body': typeof BvPopoverBodyComponent;
    }
}
